/**
 * Created by luke.denton on 9-6-16.
 */

define([
    'jquery',
    'ko',
    'uiComponent',
    'sizeSwatchSwitcher',
    'saveForLater'
], function($, ko, Component, sizeSwatchSwitcher, saveForLater) {

    /**
     * The QuickView component - the 'this' - object will be stored in this variable, allowing it to be
     * accessed when running callback functions, where the 'this' keyword is hijacked.
     *
     * @type {Component}
     */
    var QuickViewComponent = null;
    var qvProductData = {};

    return Component.extend({
        /**
         * Initialise as null.
         * Will be an <li>
         *
         * @type {*|jQuery}
         */
        $product: null,

        initialize: function () {
            this._super();

            QuickViewComponent = this;

            // Initialise click handler
            $(".product-list").on('click', '.product-tile__action--quick-view', QuickViewComponent.handlerClickQuickView);

            QuickViewComponent.productId           = ko.observable("");
            QuickViewComponent.productSku          = ko.observable("");
            QuickViewComponent.productBrand        = ko.observable("");
            QuickViewComponent.productTitle        = ko.observable("");
            QuickViewComponent.productPrice        = ko.observable("");
            QuickViewComponent.productPriceSpecial = ko.observable("");
            QuickViewComponent.productLink         = ko.observable("");
            QuickViewComponent.productCartUrl      = ko.observable("");
            QuickViewComponent.productWishlistUrl  = ko.observable("");
            QuickViewComponent.quickviewFormkey    = $("input[name='form_key']").val();
            QuickViewComponent.hasSpecialPrice     = ko.observable(false);
            QuickViewComponent.productReviewStars  = ko.observable("");
            QuickViewComponent.productReviewStarPercent  = ko.observable("");
            QuickViewComponent.productReviewCount  = ko.observable("");
            QuickViewComponent.productHasReviews     = ko.observable(false);


            /*$(".quickview-container").on("submit", "#add-to-bag-form", function(e) {
                var $swatchOptions = $(".product__sizing-sizes .swatch-option:not(.template)");
                //If there is only one size and that size is the "special" size that is for products that don't actually have a size,
                //then select that size. This is so that the product can still be added to the users cart, without them having
                //to select the size - which will be hidden from their view anyway.
                if ($swatchOptions.length === 1 && $swatchOptions.data('xeac000') === "each") {
                    $swatchOptions.trigger('click');
                }
            });*/
        },

        /**
         * Handle the event when the user clicks on the Quick View button
         *
         * @param e
         */
        handlerClickQuickView: function(e) {
            e.preventDefault();

            // Ensure quickview is empty prior to filling it
            QuickViewComponent.reset();

            QuickViewComponent.$product = $(e.target).closest(".product-list__item");

            // Show loader while ajax returns with data, but hide quickview data block
            var quickViewContainerBlock = $('.quickview-container');
            var quickViewBlock = $("#quickview");
            var loaderImgBlock = $('#quickview__loader-img');
            quickViewBlock.addClass('u-visually-hidden');
            quickViewContainerBlock.removeClass('u-visually-hidden');
            loaderImgBlock.removeClass('u-visually-hidden');

            // Populate data into quickview
            QuickViewComponent.populateVariables(e);
        },

        /**
         * Handle the event when the user clicks on the close button for the Quick View
         *
         * @param e
         */
        handlerClickCloseQuickView: function(e) {
            var $clickedElement = $(e.target);
            var isElementWithinQuickview = $clickedElement.closest('#quickview').length === 0;
            var isElementCloseButton = $clickedElement.hasClass('quickview__close-button');
            if (!isElementWithinQuickview && !isElementCloseButton) {
                return;
            }
            var $quickViewContainer = $('.quickview-container');
            var $quickView = $("#quickview");
            $quickView.closest(".quickview-container").addClass('u-visually-hidden');
            // Remove display none from size to prevent it being hidden in next quickview popup
            $(".quickview__details .product__sizing").css('display', 'block');
            // Fix bug when viewing a men shoe after women shoe
            $(".quickview__details .product__sizing .product__sizing-sizes").removeClass("men women kids girls boys prewalkers u-visually-hidden");

            QuickViewComponent.removeHandlers($quickView, $quickViewContainer);
        },

        /**
         * Handle the event when the user clicks on one of the thumbnail images in the quickview
         *
         * @param e
         *
         * @return null
         */
        handlerClickImageThumbnail: function(e) {
            var $thumbnailImage = $(e.target);
            QuickViewComponent.updateImageInMainPosition($thumbnailImage);
        },

        /**
         * Handle the event when a size swatch within the quickview is clicked
         *
         * @param {event} e The click event
         *
         * @return boolean|null
         */
        handlerClickSizeSwatch: function(e) {
            var $swatch = $(e.target);
            if ($swatch.hasClass('out-of-stock')) {
                return false;
            }
            QuickViewComponent.toggleSizeSwatchSelected($swatch);

            var $addToBagForm = $("#add-to-bag-form")
                .find("input[name^='super_attribute']")
                .attr('name', 'super_attribute['+$swatch.attr('attribute-id')+']')
                .val($swatch.attr('option-id'))
                .end();

            //Send AJAX request to server to check stock level of product
            QuickViewComponent.checkStockLevel($addToBagForm);
        },

        /**
         * This function is bound to a hidden button inside the quick view template that will be targeted when
         * any of the quick view buttons for a product is clicked
         */
        displayQuickView: function() {
            var $quickViewContainer = $('.quickview-container');
            var $quickView = $("#quickview");

            //Find the left edge of the products container
            var left = QuickViewComponent.$product.closest(".page-layout__item").find(".product-tile").offset().left;
            //Find the right edge of the products container
            var paddingLeft = QuickViewComponent.$product.css('padding-left');
            var width = QuickViewComponent.$product.closest(".page-layout__item").outerWidth() - parseInt(paddingLeft);


            var height = QuickViewComponent.$product.outerHeight();

            //Figure out the top offset to center the quickview in the page
            var windowHeight = $(window).height();
            var top = (windowHeight - height) / 2;

            $quickView.css({'width':width, 'left':left, 'top':top});
            $quickViewContainer.removeClass('u-visually-hidden');

            QuickViewComponent.attachHandlers($quickView, $quickViewContainer);
        },

        /**
         * Populate the component variables so the knockout template will update
         *
         * @return boolean
         */
        populateVariables: function(e) {
            /* Will need to change the way this all works so populatevariable fires on click, while showing a loading window.
            * In the ajax .done function need to hide the "loading" screen and show hte actual quickview with data filled
            * To do hte above - will probably have to change a few other functions in this php file. */
            var prodID = $(e.target).attr('id'); // Product ID
            $.ajax({
                //showLoader: true,
                url: "/munro_catalog/index/ajaxquickviewdata",
                data: {product: prodID},
                type: "POST"
            }).done(function (prodData) {
                if (!prodData) {
                    return false; //There is no data for this item. Possibly it is out of stock
                }

                QuickViewComponent.productSku(prodData.prodSku);
                QuickViewComponent.productBrand(prodData.prodBrand);
                QuickViewComponent.productTitle(prodData.prodName);
                QuickViewComponent.populateImages(prodData.prodImages);
                QuickViewComponent.productPrice(prodData.prodPrice);
                QuickViewComponent.productLink(prodData.prodUrl);
                QuickViewComponent.productCartUrl(prodData.prodCartUrl);
                QuickViewComponent.productWishlistUrl(prodData.prodWishlistUrl);
                QuickViewComponent.productReviewStars(prodData.prodReviewStars);
                QuickViewComponent.productReviewStarPercent(prodData.prodReviewStarPercent);
                QuickViewComponent.productReviewCount(prodData.prodReviewCount);

                //Set the hidden input values
                QuickViewComponent.productId(prodData.prodId);

                 // Check if product has review count > 0 to show div or not
                 if (prodData.prodReviewCount > 0 ) {
                    QuickViewComponent.productHasReviews(true);
                }
                else {
                    QuickViewComponent.productHasReviews(false);
                }

                // Set special price if it exists, else only show full price
                if (prodData.prodSpecialPrice === undefined || prodData.prodSpecialPrice === null || prodData.prodSpecialPrice == null || prodData.prodSpecialPrice == "" || prodData.prodSpecialPrice =="null") {
                    QuickViewComponent.productPriceSpecial("");
                    QuickViewComponent.hasSpecialPrice(false);
                } else {
                    QuickViewComponent.productPriceSpecial(prodData.prodSpecialPrice);
                    QuickViewComponent.hasSpecialPrice(true);
                }
                // Prod ID variable to be used for size.
                var prodID = prodData.prodId;
                //Sizes
                if (typeof prodData.prodSizes[prodID]["options"] !== 'undefined') {
                    QuickViewComponent.populateSizes(prodData.prodSizes[prodID]["options"]);
                }
                if (typeof prodData.prodSizes[prodID]["default_size_system"] !== 'undefined') {
                    QuickViewComponent.selectSizeSystem(prodData.prodSizes[prodID]["default_size_system"]);
                }

                // Hide loader and show the quickview window once product data has loaded
                var quickViewBlock = $("#quickview");
                var loaderImgBlock = $('#quickview__loader-img');
                loaderImgBlock.addClass('u-visually-hidden');
                quickViewBlock.removeClass('u-visually-hidden');

                QuickViewComponent.displayQuickView();

                // If product is a bag, trigger click on size automatically.
                var $swatchOptions = $(".product__sizing-sizes .swatch-option:not(.template)");
                //If there is only one size and that size is the "special" size that is for products that don't actually have a size,
                //then select that size. This is so that the product can still be added to the users cart, without them having
                //to select the size - which will be hidden from their view anyway.
                if ($swatchOptions.length === 1 && $swatchOptions.data('xeac000') === "each") {
                    $swatchOptions.trigger('click');
                }

                // Add data to variable for datalayer push
                qvProductData = [{
                    'id': prodData.prodSku,
                    'name': prodData.prodName,
                    'price': prodData.prodCleanPrice,
                    'quantity': 1,
                    'gender': prodData.prodGender,
                    'fhId': prodData.prodFhId
                }]
                return true;
            }).fail(function() {
                return false;
            });
        },

        /**
         * Populate the main image and the image thumbnails in the quick view layout
         *
         * @param {Array} images The images associated with the product being quick viewed
         *
         * @return null
         */
        populateImages: function(images) {
            var $quickViewThumbnails = $('.quickview__thumbnails');
            var numberOfImages = images.length;

            //Check if there are too few images to fill up all of the placeholders
            if (numberOfImages < 6) {
                /*
                 Loop backward from the last image placeholders position, filling each position with a blank white background,
                 which will hide the loading image, until getting to the last image placeholder that will actually have
                 an image in it.
                */
                for (var i = 6 ; i >= numberOfImages && i > 0 ; i--) {
                    $quickViewThumbnails
                        .find('.quickview__thumbnail:nth-child('+i+')')
                        .find('.quickview__thumbnail-image')
                        .attr('style', 'background-color: #FFF');
                }
            }

            $.each(images, function(index, image) {
                if (index > 5) {
                    return false; //Stops the loop
                }

                //First image will be the 'main image' to begin with
                if (index === 0) {
                    $('.quickview__main-image')
                        .find('.quickview__main-image-image')
                        .attr('style', 'background-image: url("'+image+'")');
                }

                $quickViewThumbnails
                    .find('.quickview__thumbnail:nth-child('+(index+1)+')')
                    .find('.quickview__thumbnail-image')
                    .attr('style', 'background-image: url("'+image+'")');
            });
        },

        /**
         * Populate the available sizes in the quickview details section
         *
         * @param {Object} productDataOptions The data for the product being quick-viewed
         *
         * @return null
         */
        populateSizes: function(productDataOptions) {
            var sizeAttributeId = Object.keys(productDataOptions).pop();
            var sizes = productDataOptions[sizeAttributeId].values;
            // Get the size system options based on whether the first size has a male size value
            // (if the first is a male size then we can assume that they all are).
            var sizeGender = sizeSwatchSwitcher.getSizeGender(sizes[0].original_size);
            var sizeSystemOptions = sizeSwatchSwitcher.getAllSizeSystemOptions(sizeGender);
            $(".product__sizing-selector").append(
                '<select class="size-switcher">' + sizeSystemOptions + '</select>'
            );

            var $quickviewSizingSizes = $("#quickview").find(".product__sizing-sizes");

            var $sizeTemplate = $quickviewSizingSizes.find(".template");

            var maleSizes = false;
            $.each(sizes, function(id, size) {
                var $sizeSwatch = $sizeTemplate.clone()
                    .removeClass('template')
                    .attr('option-id', size['option_id']);

                var euSizeCode = '';
                $.each(size, function(sizeSystem, size) {

                    //"XEAC000" has been selected as a "special" size that indicates there is no size for a product, e.g. Handbags
                    //In these cases, there is no point in showing the sizes
                    if (sizeSystem === "XEAC000") {
                        $(".product__sizing").hide();
                    }
                    //Store the EU size code. Will be used below for the label and a couple of attributes
                    if (/^eu/i.test(sizeSystem)) {
                        euSizeCode = sizeSystem;
                    }
                    $sizeSwatch.attr('data-'+sizeSystem, size);
                });

                if (euSizeCode === "EUM") {
                    //As soon as one of the sizes is male, then the assumption is that all sizes are male
                    maleSizes = true;
                }

                $sizeSwatch
                    .text(size[euSizeCode])
                    .attr('attribute-id', sizeAttributeId)
                    .attr('option-label', size[euSizeCode])
                    .attr('option-tooltip-value', size[euSizeCode])
                    .toggleClass('out-of-stock', size['munro_qty'] === 0);

                $sizeSwatch.appendTo(".product__sizing-sizes");
            });

            $(".product__sizing-sizes").addClass(sizeGender).attr('data-swatch-filters-container', sizeGender)
        },

        selectSizeSystem: function(system) {
            sizeSwatchSwitcher.selectSizeSystem(system, this);
        },

        /**
         * Toggle the selected state of a size swatch in quickview, and make sure all other swatches are not selected
         *
         * @param $swatch
         *
         * @return null
         */
        toggleSizeSwatchSelected: function($swatch) {
            //First, un-select the previously selected swatch (if any).
            $swatch.closest(".swatch-attribute").find(".swatch-option").toggleClass('selected', false);

            QuickViewComponent.setSelectedSku($swatch.attr('data-sku'));

            //Update the swatch that was clicked to be highlighted
            $swatch.toggleClass('selected');
        },

        /**
         * Update the image that is currently displayed as the 'main image'
         *
         * This is done by swapping the image that's currently in that position with the one provided in the
         * first parameter
         *
         * @param {jQuery} $selectedThumbnail The new image to display in the large, main image position
         *
         * @return null
         */
        updateImageInMainPosition: function ($selectedThumbnail) {
            var $currentMainImage = $(".quickview__main-image-image");
            var newMainImage_cssBackgroundImage = $selectedThumbnail.css('background-image');
            $currentMainImage.css('background-image', newMainImage_cssBackgroundImage);
        },

        /**
         * Attach javascript handlers to Quickview elements
         *
         * @return null
         */
        attachHandlers: function($quickView, $quickViewContainer) {
            saveForLater({
                eventAnchor: $quickViewContainer,
            });

            $quickView.on('click', '.quickview__close-button', QuickViewComponent.handlerClickCloseQuickView);
            $quickView.on('click', '.quickview__thumbnail-image', QuickViewComponent.handlerClickImageThumbnail);
            $quickView.on('click', '.swatch-option', QuickViewComponent.handlerClickSizeSwatch);
            $quickViewContainer.on('click', QuickViewComponent.handlerClickCloseQuickView);
        },

        /**
         * Remove handlers that were attached when the Quickview was displayed.
         * This should be run when the quickview is closed
         */
        removeHandlers: function($quickView, $quickViewContainer) {
            $quickView.off('click', '.quickview__close-button');
            $quickViewContainer.off('click');
            $quickView.off('click', '.quickview__thumbnail-image');
            $quickView.off('click', '.swatch-option');
        },

        /**
         * Reset the QuickView component so that subsequent products being quickviewed don't have left over data
         * from a previous product
         *
         * @returns null
         */
        reset: function() {
            $(".quickview__save-button").text('Save for Later');
            $(".product__stock-message").text('');
            QuickViewComponent.resetImages();
            QuickViewComponent.resetSizes();
        },

        /**
         * Remove the background-image CSS properties from all of the images in the quick view.
         *
         * This is essentially resetting the quickview so that there aren't images left over from a previous product
         * if the next product being quick-viewed only has a couple of images
         *
         * @return null
         */
        resetImages: function() {
            var $images = $(".quickview__thumbnail-image, .quickview__main-image-image");
            $images.each(function(index, image) {
                var $image = $(image);
                $image.css('background-image', '');
            });
        },

        /**
         * Remove the size selector and swatches, so the next product can create them fresh
         *
         * @returns null
         */
        resetSizes: function() {
            $(".product__sizing-selector").html('');
            $(".product__sizing-sizes").find(".swatch-option:not(.template)").remove();
        },

        /**
         * Check the stock level of a product in a specific size
         *
         * @param {Object} $addToBagForm The form around the Add to bag button, which will contain all required params
         *
         * @returns {int}
         */
        checkStockLevel: function($addToBagForm) {
            $.ajax({
                url: "/munro_catalog/index/checklowstockforsize",
                type: 'POST',
                data: $addToBagForm.serialize()
            })
            .done(function(data) {
                var $productStockMessage = $(".product__stock-message");
                if (data.message) {
                    $productStockMessage.text(data.message);
                } else {
                    $productStockMessage.text('');
                }
            });
        },

        /**
         *
         *
         */
        ajaxAddToCart: function(data, event) {
            event.preventDefault();
            var $productStockMessage = $(".product__stock-message");
            // If there is no size selected, show an error and don't submit form
            var noSize = $('#quickview .swatch-option.selected');
            if(noSize.length == 0) {
                var noSizeMessage = 'You need to choose options for your item.';
                $productStockMessage.text(noSizeMessage);
            }
            else {
                $productStockMessage.text('');
                var clickedClassName = event.target.className; // Class of add to cart button
                var theForm = $('.' + clickedClassName).closest("form"); // Add to cart form

                // Show adding to cart popup
                $('#quickview .quickview__adding-to-cart').show();

                $.ajax({
                    // Submit the form via ajax instead of standard form submit.
                    type: theForm.attr('method'),
                    url: theForm.attr('action'),
                    data: theForm.serialize(),
                    success: function(data) {
                        // Push to cart event here because of custom quickview ajax add to cart not default magento. See notes in MMI-1443
                        var dataLayer = window.dataLayer || [];
                        dataLayer.push({
                            'event': 'addToCart',
                            'ecommerce': {
                                'add': {
                                    'products': qvProductData
                                }
                            }
                        });
                        dataLayer.push({
                            'event': 'add_to_cart',
                            'ecommerce': {
                                'items': [{
                                    'item_id': qvProductData[0].id,
                                    'item_name': qvProductData[0].name,
                                    'price': qvProductData[0].price,
                                    'quantity': qvProductData[0].quantity,
                                    'gender': qvProductData[0].gender,
                                    'fhId': qvProductData[0].fhId,
                                    'web_categories': qvProductData[0].web_categories
                                }]
                            }
                        });
                    }
                })
                .done(function (data) {
                    var $quickviewContainer = $('.quickview-container');
                    // Get the name of the product that was just visble in the quickview - assumption is this is the product that was just added to cart
                    var productName = $quickviewContainer.find(".quickview__title").text().toUpperCase();

                    $('#quickview .quickview__adding-to-cart').hide();
                    $quickviewContainer.addClass('u-visually-hidden');
                })
                .fail(function (data) {
                    // Fail reload to show message
                    location.reload();
                });
            }
        },

        /**
         * Set the value of the hidden input
         *
         * @param {string} sku The SKU value of the simple product selected
         *
         * @returns {null}
         */
        setSelectedSku: function (sku) {
            $("#selected_simple_product_sku").val(sku);
        }
    });

});
